import React from "react";
import Seltos   from "../../Brochure/Seltos/Seltos.pdf";
import Sonet    from "../../Brochure/Sonet/Sonet.pdf";
import Carens   from "../../Brochure/Carens/Carens.pdf";
import EV6      from "../../Brochure/EV6/Kia-EV6_Desktop.pdf";
import Carnival from "../../Brochure/Carnival/Kia_Carnival_Brochure_Desktop.pdf";
import EV9      from "../../Brochure/Ev9/Ev9.pdf";
import Syros    from "../../Brochure/Syros/Kia_Syros_2025_Desktop.pdf";
import "./BrochurePage.css";

const SyrosEvBrochure =
  "https://www.kia.com/content/dam/kia2/in/en/our-vehicles/syros/Kia_Syros_2025_Desktop.pdf";

const SorentoBrochure =
  "https://www.kia.com/content/dam/kia2/in/en/images/our-vehicles/sonetro/showroom/The_Kia_Sorento_Brochure_D.pdf";

const cars = [
  { name: "Seltos",   label: "Kia Seltos",   img: "https://firebasestorage.googleapis.com/v0/b/kia-central.firebasestorage.app/o/model%2Fseltos.avif?alt=media&token=571bd65b-651c-49b3-8ede-e97ed5c0993a",   brochure: Seltos,   file: "Kia_Seltos_Brochure.pdf" },
  { name: "Sonet",    label: "Kia Sonet",    img: "https://firebasestorage.googleapis.com/v0/b/kia-central.firebasestorage.app/o/model%2Fsonet.avif?alt=media&token=3e494dad-c44e-4c25-96da-43d4d707a850",    brochure: Sonet,    file: "Kia_Sonet_Brochure.pdf" },
  { name: "Carens",   label: "Kia Carens",   img: "https://firebasestorage.googleapis.com/v0/b/kia-central.firebasestorage.app/o/model%2Fcarens1.avif?alt=media&token=8fa66c98-8f14-4d5d-85d7-312e75f51e9e",  brochure: Carens,   file: "Kia_Carens_Brochure.pdf" },
  { name: "EV6",      label: "Kia EV6",      img: "https://firebasestorage.googleapis.com/v0/b/kia-central.firebasestorage.app/o/model%2Fev6.avif?alt=media&token=c6f607aa-bdcb-4c22-8f2c-04e5429aade9",      brochure: EV6,      file: "Kia_EV6_Brochure.pdf" },
  { name: "Carnival", label: "Kia Carnival", img: "https://firebasestorage.googleapis.com/v0/b/kia-central.firebasestorage.app/o/model%2Fcarnival.avif?alt=media&token=22bfdbc1-1a0e-4a5f-96d4-7a5a468d38ca", brochure: Carnival, file: "Kia_Carnival_Brochure.pdf" },
  { name: "EV9",      label: "Kia EV9",      img: "https://firebasestorage.googleapis.com/v0/b/kia-central.firebasestorage.app/o/model%2Fev9.avif?alt=media&token=8f7f3f13-aae5-4662-a42d-c46c8523f123",      brochure: EV9,      file: "Kia_EV9_Brochure.pdf" },
  { name: "Syros",    label: "Kia Syros",    img: "https://firebasestorage.googleapis.com/v0/b/kia-central.firebasestorage.app/o/model%2Fsuv_syros.avif?alt=media&token=53f06690-20aa-466b-9aad-6720d9868df3", brochure: Syros,    file: "Kia_Syros_2025_Desktop.pdf" },
  { name: "Syros EV", label: "Kia Syros EV", img: "https://firebasestorage.googleapis.com/v0/b/kia-central.firebasestorage.app/o/syros-ev%2F08-d.avif?alt=media&token=2940b50d-4d07-46cb-ae43-3de7008ae9fe", brochure: SyrosEvBrochure, file: "Kia_Syros_EV_Brochure.pdf" },
  { name: "Sorento",  label: "Kia Sorento",  img: "https://www.kia.com/content/dam/kia2/in/en/our-vehicles/sorento/Kia-Sorento-Car-600x300.png", brochure: SorentoBrochure, file: "The_Kia_Sorento_Brochure.pdf" },
];

const BrochurePage = () => (
  <div className="br-root">

    {/* ── HERO ── */}
    <section className="br-hero">
      <div
        className="br-hero__bg"
        style={{
          backgroundImage: `url(https://firebasestorage.googleapis.com/v0/b/kia-central.firebasestorage.app/o/featureData%2FWhatsApp%20Image%202026-05-30%20at%2014.15.50.jpeg?alt=media&token=a164188b-d82b-4ee8-a306-54346f6c9af6)`,
        }}
      />
      <div className="br-hero__overlay" />
      <div className="br-hero__content">
        <span className="br-hero__eyebrow">Central Kia</span>
        <h1 className="br-hero__title">Kia Brochures</h1>
        <p className="br-hero__desc">
          Download the official brochure for any model and explore every detail at your own pace.
        </p>
      </div>
    </section>

    {/* ── INTRO STRIP ── */}
    <section className="br-intro">
      <div className="br-intro__inner">
        <p className="br-intro__text">
          Choose from <strong>{cars.length} models</strong> — each brochure contains full specifications, variant details, colour options, and pricing. Download, save, and share.
        </p>
      </div>
    </section>

    {/* ── GRID ── */}
    <section className="br-section">
      <div className="br-section__inner">
        <div className="br-grid">
          {cars.map((car) => (
            <div className="br-card" key={car.name}>
              <div className="br-card__img-wrap">
                <img
                  src={car.img}
                  alt={car.label}
                  className="br-card__img"
                  loading="lazy"
                  decoding="async"
                />
              </div>
              <div className="br-card__body">
                <p className="br-card__model">{car.name.toUpperCase()}</p>
                <h3 className="br-card__name">{car.label}</h3>
                <a
                  href={car.brochure}
                  download={car.file}
                  className="br-card__btn"
                >
                  <svg width="13" height="13" viewBox="0 0 24 24" fill="none"
                    stroke="currentColor" strokeWidth="2.5"
                    strokeLinecap="round" strokeLinejoin="round">
                    <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/>
                    <polyline points="7 10 12 15 17 10"/>
                    <line x1="12" y1="15" x2="12" y2="3"/>
                  </svg>
                  Download Brochure
                </a>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>

    {/* ── CTA BAND ──
    <section className="br-cta">
      <div className="br-cta__inner">
        <h2 className="br-cta__title">Ready to Take a Test Drive?</h2>
        <p className="br-cta__body">
          Like what you see in the brochure? Visit our showroom or book a test drive today.
        </p>
        <div className="br-cta__btns">
          <a href="/test-drive" className="br-cta__btn br-cta__btn--white">Book Test Drive</a>
          <a href="/contact"   className="br-cta__btn br-cta__btn--ghost">Contact Us</a>
        </div>
      </div>
    </section> */}

  </div>
);

export default BrochurePage;